// extracted by mini-css-extract-plugin
export default {"contactList__mainContainer":"adminPanel_contactList__mainContainer__lYgpd","contactList__buttonContainer":"adminPanel_contactList__buttonContainer__YG46v"};